var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-4 rounded",class:{
    'bg-red-300': _vm.color === 'red',
    'bg-yellow-300': _vm.color === 'yellow',
    'bg-green-300': _vm.color === 'green',
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }